import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#001a2d] py-10 px-4" data-id="element-209">
      <div className="max-w-5xl mx-auto" data-id="element-210">
        {/* Stats */}
        <div className="grid grid-cols-4 gap-4 mb-10 text-center" data-id="element-211">
          <div data-id="element-212">
            <div className="text-3xl sm:text-5xl font-black text-white" data-id="element-213">
              +300
            </div>
            <div className="text-[#00B4D8] text-xs sm:text-sm font-semibold mt-1" data-id="element-214">
              profes confían
            </div>
          </div>
          <div data-id="element-215">
            <div className="text-3xl sm:text-5xl font-black text-white" data-id="element-216">
              6+6
            </div>
            <div className="text-[#00B4D8] text-xs sm:text-sm font-semibold mt-1" data-id="element-217">
              Tomos + Bonos
            </div>
          </div>
          <div data-id="element-218">
            <div className="text-3xl sm:text-5xl font-black text-white" data-id="element-219">
              4.9/5
            </div>
            <div className="text-[#00B4D8] text-xs sm:text-sm font-semibold mt-1" data-id="element-220">
              calificación ⭐
            </div>
          </div>
          <div data-id="element-221">
            <div className="text-3xl sm:text-5xl font-black text-white" data-id="element-222">🇦🇷</div>
            <div className="text-[#00B4D8] text-xs sm:text-sm font-semibold mt-1" data-id="element-223">
              Todo el país
            </div>
          </div>
        </div>

        {/* Micro testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-id="element-224">
          <div className="flex items-start gap-3 bg-black/40 border border-[#00B4D8]/20 rounded-xl p-4" data-id="element-225">
            <div className="w-9 h-9 rounded-full bg-[#00B4D8]/20 flex items-center justify-center text-[#00B4D8] font-black text-xs flex-shrink-0" data-id="element-226">
              MR
            </div>
            <div data-id="element-227">
              <div className="text-[#00B4D8] text-xs mb-1" data-id="element-228">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-229">
                "Organicé todo el año en una tarde. Cada clase lista y
                secuenciada."
              </p>
              <p className="text-gray-400 text-xs mt-1" data-id="element-230">
                — Martín R., Buenos Aires
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#00B4D8]/20 rounded-xl p-4" data-id="element-231">
            <div className="w-9 h-9 rounded-full bg-[#00B4D8]/20 flex items-center justify-center text-[#00B4D8] font-black text-xs flex-shrink-0" data-id="element-232">
              CS
            </div>
            <div data-id="element-233">
              <div className="text-[#00B4D8] text-xs mb-1" data-id="element-234">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-235">
                "Mis juniors subieron de categoría por primera vez en años."
              </p>
              <p className="text-gray-400 text-xs mt-1" data-id="element-236">
                — Carolina S., Rosario
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#00B4D8]/20 rounded-xl p-4" data-id="element-237">
            <div className="w-9 h-9 rounded-full bg-[#00B4D8]/20 flex items-center justify-center text-[#00B4D8] font-black text-xs flex-shrink-0" data-id="element-238">
              DV
            </div>
            <div data-id="element-239">
              <div className="text-[#00B4D8] text-xs mb-1" data-id="element-240">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-241">
                "Abro el PDF y en 3 minutos tengo la clase lista. Antes tardaba
                horas."
              </p>
              <p className="text-gray-400 text-xs mt-1" data-id="element-242">— Diego V., Córdoba</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}